// Live's image Advanced mode (#234, G8): its caps, its words and when its ad copies can be set
// up (`pages/images/schema.ts`, `utils.ts` `getAdvancedPlaceholder`, `advanced-configuration`).
import type { Catalog, CatalogImageModel } from "../../../api/generated/model";

/** Live's `ALLOWED_ADVANCED_REFERENCES_COUNT`: the references an Advanced draft takes. */
export const ADVANCED_REFERENCES = 5;

/** Live's Style editor (`STYLE_ADVANCE_IMAGES_PLACEHOLDER`) and its Save's minimum length. */
export const STYLE_PLACEHOLDER =
  "Clean, minimalist design with soft gradients. Hero product centred with subtle shadow. " +
  "Bold sans-serif typography. Accent colors that pop against neutral background. Trust " +
  "badges bottom-right.";
export const STYLE_MIN_CHARS = 10;

/** Live's tooltip on the Ad copies chip while it cannot be used (its code's words). */
export const AD_COPIES_TIP =
  "Ad copies will be available once you select a product and add at least one reference image " +
  "or visual style";

/** Live's words on the bolt while there is no price (`uft-estimate/constants.ts`). */
export const UNPRICED = "We couldn’t calculate the estimated generation cost right now.";

/** Live's tooltip on the Advanced count. */
export const COUNT_TIP = "Number of images generated with the current settings.";

/**
 * The models Advanced lists: those whose rows serve `image.advanced`. Live lists the ones that
 * make ad creatives (its `supportAdcopyFlow`, our `ad_copy`); ours lists only those that can start
 * the job, the Gemini rows until G8's PR 3c serves the rest.
 */
export function advancedModels(catalog: Catalog): CatalogImageModel[] {
  return catalog.image_models.filter((model) => model.job_types.includes("image.advanced"));
}

/** What the ad copies need first: a product, and a reference image or a Style. */
export interface AdvancedSetup {
  product: boolean;
  references: number;
  style: string;
}

/** Live's `isCanSetupTextCopies`. */
export function canSetupCopies(setup: AdvancedSetup): boolean {
  return setup.product && (setup.references > 0 || setup.style.trim() !== "");
}

/** Live's line in place of the prompt (`getAdvancedPlaceholder`). */
export function helperText(canSetup: boolean, analysing: boolean): string {
  if (analysing) return "Image analysis in progress. You’ll be able to continue shortly.";
  return canSetup
    ? "Finish the setup in Ad copies."
    : "Please choose a product and add at least one reference image or a visual style to get started.";
}
